<div class="warehouse-container">
  <form [formGroup]="warehouseForm" class="manage-warehouse-form">
    <div class="form-row">
      <div class="form-group">
        <label class="required_field_label" for="name">Warehouse Name</label>
        <input
          id="name"
          formControlName="name"
          placeholder="Enter Warehouse Name"
          [ngClass]="{
            form_error:
              warehouseForm.get('name')?.invalid &&
              warehouseForm.get('name')?.touched
          }"
        />
        <div
          class="form_validation_error_new"
          [ngClass]="{
            visible:
              warehouseForm.get('name')?.invalid &&
              warehouseForm.get('name')?.touched
          }"
        >
          <small *ngIf="warehouseForm.get('name')?.errors?.['required']">
            Warehouse Name is required
          </small>
        </div>
      </div>

      <div class="form-group">
        <label class="required_field_label" for="totalVolume">Total Volume</label>
        <input
          type="number"
          step="1"
          min="1"
          id="totalVolume"
          formControlName="totalVolume"
          placeholder="Enter Volume"
          [ngClass]="{
            form_error:
              warehouseForm.get('totalVolume')?.invalid &&
              warehouseForm.get('totalVolume')?.touched
          }"
        />
        <div
          class="form_validation_error_new"
          [ngClass]="{
            visible:
              warehouseForm.get('totalVolume')?.invalid &&
              warehouseForm.get('totalVolume')?.touched
          }"
        >
          <small *ngIf="warehouseForm.get('totalVolume')?.errors?.['required']">
            Total Volume is required
          </small>
           <small *ngIf="warehouseForm.get('totalVolume')?.errors?.['min']">
            Value must be greater than 0
          </small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group" style="grid-column: span 2">
        <label for="description" class="form-label">Description</label>
        <textarea
          class="form-text-area"
          id="description"
          placeholder="Enter description"
          formControlName="description"
        ></textarea>
      </div>
    </div>
  </form>
</div>
